(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"), require("angular-material"));
	else if(typeof define === 'function' && define.amd)
		define("mdMaterialZippy", ["angular", "angular-material"], factory);
	else if(typeof exports === 'object')
		exports["mdMaterialZippy"] = factory(require("angular"), require("angular-material"));
	else
		root["mdMaterialZippy"] = factory(root["angular"], root["angular-material"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition